import { useEffect } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../../../store";
import { marketCode, storedLocale } from "../../../Authentication/util";
import { useGetSeriesDataviewQuery } from "../../../../services/AboProfile/AboProfileAPI";
import { setSelectedKpis, setAvailableKpis } from "../../../../reducers/downlineProfile";
import { KpiSeries } from "../../shared/types";
import "./PerformanceMetrics.scss";

import RawDataView from "../../shared/RawDataView/RawDataView";
import MetricCard from "./MetricCard/MetricCard";
import { NoKpiData } from "../../shared/TrendChart/TrendChart";
import { useTranslation } from "react-i18next";
import { getTotalNulls } from "../../Export/util/basic";

const PerformanceMetrics = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["downlineProfile", "keyMetrics"]);
  const downlineProfileAffAbo = useAppSelector((state: RootState) => state.downlineProfile.affAbo);
  const view = useAppSelector((state: RootState) => state.downlineProfile.viewMode);
  const isApplyingKpis = useAppSelector((s) => s.downlineProfile.isApplyingKpis);
  const [aff = "", abo = ""] = downlineProfileAffAbo.split("-");
  const { currentData, isFetching, isError, refetch } = useGetSeriesDataviewQuery(
    {
      aff,
      abo,
      locale: storedLocale(),
      dataViewID: "downlineProfile",
      market: marketCode(),
    },
    { skip: !aff || !abo },
  );

  useEffect(() => {
    dispatch(setSelectedKpis(currentData?.selectedKpis ?? []));
    dispatch(setAvailableKpis(currentData?.availableKpis ?? []));
  }, [currentData, dispatch]);
  const orderIndex = (kpi?: string) => {
    const i = currentData?.selectedKpis?.indexOf(kpi ?? "") ?? -1;
    return i === -1 ? Infinity : i;
  };

  const sortedSeries = [...(currentData?.series ?? [])].sort((a, b) => orderIndex(a?.kpi) - orderIndex(b?.kpi));
  if (isFetching && !currentData && view === "graphView") {
    return (
      <div className="performance-metrics--graphView">
        {Array.from({ length: 4 }).map((_, i) => (
          <MetricCard key={i} isLoading={true} isError={false} />
        ))}
      </div>
    );
  }

  const totalNulls = getTotalNulls(currentData?.series);
  if (totalNulls === currentData?.series.length && !isError && !isFetching && !isApplyingKpis) {
    return (
      <div className="metric-no-data-wrapper">
        <NoKpiData t={t} />
      </div>
    );
  }
  return (
    <>
      <div className={`performance-metrics--${view}`}>
        {view === "graphView" &&
          (sortedSeries.length ? sortedSeries : [null, null, null, null]).map((series, i) => {
            return (
              <MetricCard
                key={i}
                series={series}
                endPeriod={currentData?.endPeriod}
                isLoading={isFetching || isApplyingKpis}
                isError={isError}
                onRetry={() => refetch()}
              />
            );
          })}
        {view === "tableView" && (
          <RawDataView
            series={currentData?.series}
            selectedKpis={currentData?.selectedKpis}
            locale={storedLocale()}
            endPeriod={currentData?.endPeriod}
            selectedPerformanceYear={2026}
            isLoading={isFetching || isApplyingKpis}
            isError={isError}
            retry={() => refetch()}
          />
        )}
      </div>
    </>
  );
};

export default PerformanceMetrics;
